export class Ocorrencia {
    public id: number;
    public dataInclusao: Date;
    public dataEncerramento: Date;
    public justificativa: string;
    public justificativaEncerramento: string;
    public desclassificarEstudo: boolean;
    public codigoEstudoSocioEconomico: number;
    public idUsuario: number;
}

